module.exports = __webpack_public_path__ + "static/media/TN-Women-Knit.4d7aad75.svg";